import { getAuthenticated } from '../../../../../../services/RestTemplate';
import { alertsApi } from '../../../../alerts/list/redux/backend';
import { objToUrlParams } from '../../../../../../shared/helpers/url-params.helper';

const playersUrl = '/players/';

export function getPlayerEvents(playerId, args) {
    const urlParams = objToUrlParams(args);
    const playerEventsApi = playersUrl + playerId + '/events' + urlParams;

    return getAuthenticated(playerEventsApi);
}

export function getPlayerAlerts(args) {
    const urlParams = objToUrlParams(args);

    const playerAlertsApi = alertsApi + urlParams;

    return getAuthenticated(playerAlertsApi);
}

export function getPlayerById(id) {
    const getPlayerByIdUrl = playersUrl + '/' + id;

    return getAuthenticated(getPlayerByIdUrl);
}
